import HowItWorksPage1 from "components/pages/how-it-works/HowItWorksPage1";
import useLogPageView from "hooks/useLogPageView";

export default function HowItWorksPage(): JSX.Element {
  useLogPageView();
  return <HowItWorksPage1 />;
}
